import {
  ContributionRelationshipEnum,
  type ContributionRelationship,
} from '../../domain/enums/contribution.enum'
import {
  RELATIONSHIP_CONFIG,
  RelationshipBadgeEnum,
  type RelationshipBadge,
} from '../constants/relationship-badge.constants'

const CONTRIBUTION_RELATIONSHIP_TO_BADGE: Record<
  ContributionRelationship,
  RelationshipBadge
> = {
  [ContributionRelationshipEnum.EMPLOYEE]: RelationshipBadgeEnum.EMPLOYEE,
  [ContributionRelationshipEnum.SPOUSE]: RelationshipBadgeEnum.SPOUSE,
  [ContributionRelationshipEnum.CHILD]: RelationshipBadgeEnum.CHILD,
  [ContributionRelationshipEnum.ADULT_CHILD]: RelationshipBadgeEnum.ADULT_CHILD,
  [ContributionRelationshipEnum.DOMESTIC_PARTNER]:
    RelationshipBadgeEnum.DOMESTIC_PARTNER,
  [ContributionRelationshipEnum.CHILD_OF_DOMESTIC_PARTNER]:
    RelationshipBadgeEnum.CHILD_OF_DOMESTIC_PARTNER,
}

export function mapContributionRelationshipToBadge(
  contributionRelationship: ContributionRelationship
): RelationshipBadge {
  return CONTRIBUTION_RELATIONSHIP_TO_BADGE[contributionRelationship]
}

export function mapRelationshipDisplayToBadge(
  display: string
): RelationshipBadge | null {
  const trimmedDisplay = display.trim()
  if (!trimmedDisplay) {
    return null
  }

  const normalizedKey = trimmedDisplay
    .toUpperCase()
    .replace(/\s+/g, '_') as RelationshipBadge

  if (normalizedKey in RELATIONSHIP_CONFIG) {
    return normalizedKey
  }

  const displayLower = trimmedDisplay.toLowerCase()
  for (const [relationshipBadge, config] of Object.entries(
    RELATIONSHIP_CONFIG
  )) {
    if (config.label.toLowerCase() === displayLower) {
      return relationshipBadge as RelationshipBadge
    }
  }

  return null
}

/** @deprecated Use mapRelationshipDisplayToBadge */
export const mapRelationshipDisplayToRelationship =
  mapRelationshipDisplayToBadge
